import {
  CREATE_MEMBERSHIP,
  DELETE_MEMBERSHIP,
  UPDATE_MEMBERSHIPS,
  GET_MEMBERSHIPS,
  SET_MEMBERSHIPS
} from '@/store/mutation-types'
import { membershipService } from '@/services/membership-service'
import { normalize } from 'normalizr'
import { schemas } from '@/store/schemas'
import _ from 'lodash'
import Vue from 'vue'

export const namespaced = false

export const state = {
  memberships: {},
  roles: {}
}

export const mutations = {
  [SET_MEMBERSHIPS](state, result) {
    state.memberships = { ...result.entities.memberships }
    state.roles = { ...state.roles, ...result.entities.roles }
  },
  [DELETE_MEMBERSHIP](state, membershipId) {
    Vue.delete(state.memberships, membershipId)
  }
}

export const actions = {
  [GET_MEMBERSHIPS](context, organizationId) {
    membershipService.list(organizationId).then(response => {
      let result = normalize(response.data, schemas.membershipList)
      context.rootState.users = { ...context.rootState.users, ...result.entities.users }
      context.commit(SET_MEMBERSHIPS, result)
    })
  },
  [CREATE_MEMBERSHIP]({ dispatch }, membership) {
    return new Promise(res => {
      membershipService.create(membership).then(response => {
        dispatch(GET_MEMBERSHIPS, membership.organization.id)
        res(response.data)
      })
    })
  },
  [DELETE_MEMBERSHIP]({ commit }, { organizationId, membershipId }) {
    return new Promise(res => {
      membershipService.delete(organizationId, membershipId).then(response => {
        commit(DELETE_MEMBERSHIP, membershipId)
        res(response.data)
      })
    })
  },
  [UPDATE_MEMBERSHIPS]({ dispatch }, { organizationId, username, roles }) {
    return new Promise(res => {
      membershipService
        .update(organizationId, {
          user: {
            username: username
          },
          userRoles: _.map(roles, it => {
            return { id: it }
          })
        })
        .then(response => {
          dispatch(GET_MEMBERSHIPS, organizationId)
          res(response.data)
        })
    })
  }
}

export const getters = {}
